var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { SystemParamService } from '~/services/management-service/system-param.service';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import FileUpLoad from '~/components/common/file-upload.vue';
import clone from 'clone';
var ModifyParameter = /** @class */ (function (_super) {
    __extends(ModifyParameter, _super);
    function ModifyParameter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifyParams = {
            description: '',
            id: '',
            paramCode: '',
            paramName: '',
            paramStatus: 'ENABLED',
            paramValue: '',
        };
        _this.rules = {
            paramCode: [{ required: true, message: '请输入参数代码' }],
            paramName: [{ required: true, message: '请输入参数名称' }],
            paramStatus: [{ required: true, message: '请选择是否启用' }],
            paramValue: [{ required: true, message: '请输入参数值' }],
        };
        return _this;
    }
    ModifyParameter.prototype.refreshList = function () { };
    ModifyParameter.prototype.modifyDataChange = function (value) {
        if (!value)
            return;
        this.modifyParams = clone(value);
    };
    /**
     * 取消
     */
    ModifyParameter.prototype.cancel = function () {
        //   关闭修改参数dialog
        this.$emit('close');
        // 重置form表单
        var modifyForm = this.$refs['modify-form'];
        modifyForm.resetFields();
    };
    ModifyParameter.prototype.modifyCommit = function () {
        var _this = this;
        var form = this.$refs['modify-form'];
        form.validate(function (result) {
            if (!result)
                return;
            _this.sysParamService.modifySystemParam(_this.modifyParams).subscribe(function (data) {
                _this.$message.success('操作成功');
                _this.refreshList();
                _this.$emit('close');
            });
        });
    };
    __decorate([
        Dependencies(SystemParamService)
    ], ModifyParameter.prototype, "sysParamService", void 0);
    __decorate([
        Prop({})
    ], ModifyParameter.prototype, "modifyData", void 0);
    __decorate([
        Emit('refreshList')
    ], ModifyParameter.prototype, "refreshList", null);
    __decorate([
        Watch('modifyData', { immediate: true })
    ], ModifyParameter.prototype, "modifyDataChange", null);
    ModifyParameter = __decorate([
        Component({
            components: {
                FileUpLoad: FileUpLoad,
            },
        })
    ], ModifyParameter);
    return ModifyParameter;
}(Vue));
export default ModifyParameter;
